import React from "react";
import arrowUprightWhite from "../../../../../assets/imgs/chevron_right.svg";
import { formatDateTime } from "../../Services";
import ChatHistorySkeleton from "../ChatHistorySkeleton";
import { actions } from "../../../../../Redux/store";
import { useMixpanel } from "../../../../../Context/MixpanelContext/MixpanelProvider";

interface ChatBotHistoryListProps {
  isLoading: boolean;
  conversationHistory: any[];
}

const ChatBotHistoryList: React.FC<ChatBotHistoryListProps> = ({
  isLoading,
  conversationHistory,
}) => {
  const Mixpanel = useMixpanel();
  const openChatbotSearchModal = (thread_id: string | null) => {
    Mixpanel.trackEvent("previous_chat_selected", {
      name: "User clicked on a previous chat",
      thread_id: thread_id,
    });
    actions.modal.openChatbotSearchModal({ thread_id: thread_id });
  };

  return (
    <>
      {isLoading ? (
        <ChatHistorySkeleton count={6} />
      ) : (
        <div className="p-[20px] space-y-4">
          {conversationHistory.length > 0 ? (
            conversationHistory.map((item, index) => (
              <div
                key={index}
                className={`flex justify-between items-center cursor-pointer pb-3 ${
                  index !== conversationHistory.length - 1
                    ? "border-b border-white/15"
                    : ""
                }`}
                // onClick={() => onHistoryItemClick(item)}
                onClick={() => openChatbotSearchModal(item.thread_id)}
              >
                <div className="flex-col space-y-[2px]">
                  <div>
                    <span className="text-[13px] font-medium text-white">
                      {item.title || "-"}
                    </span>
                  </div>
                  <div>
                    <span className="text-[11px] font-medium text-white/70">
                      {formatDateTime(item.created_at)}
                    </span>
                  </div>
                </div>
                <div>
                  <img src={arrowUprightWhite} alt="arrowUpright" />
                </div>
              </div>
            ))
          ) : (
            <div className="p-4 mt-4 text-center text-white/50">
              <p className="font-medium">No chat history found</p>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ChatBotHistoryList;
